// extracted by mini-css-extract-plugin
export var body = "Callout-module--body--3b2a1";
export var card = "Callout-module--card--6896b";
export var list = "Callout-module--list--4e855";
export var listItem = "Callout-module--listItem--d9e32";
export var title = "Callout-module--title--db907 typography-module--bodySmall--d4a98";